<template>
  <span :class="`delta-overlay ${classes}`">
    {{ text }}
    <span
      v-if="delta > 0"
      :class="`delta-overlay__delta ${delta_classes}`"
      :style="overlay_position"
    >
      <span> +{{ delta }} </span>
    </span>
  </span>
</template>

<script>
export default {
  name: 'delta-overlay',
  props: {
    text: String,
    delta: Number,
    classes: {
      type: String,
      default: () => '',
    },
    delta_classes: {
      type: String,
      default: () => '',
    },
    overlay_position: {
      type: Object,
      default: () => ({
        top: '-5px',
      }),
    },
  },
};
</script>

<style lang="scss" scoped>
.delta-overlay {
  position: relative;
  &__delta {
    z-index: 1;
    right: -12.5px;
    position: absolute;
    font-size: 12px;
    font-weight: $vb-font-weight-semibold;
  }
}
</style>
